import { createContext } from "react";

const HomePageContext = createContext({});

export default HomePageContext;
